<h2 mat-dialog-title>

  <span *ngIf="selectedHomeCarouselItem.title">{{'COMMON.EDIT' | translate}} - {{selectedHomeCarouselItem.title}}</span>
  <span *ngIf="!selectedHomeCarouselItem.title">{{'COMMON.CREATE_NEW' | translate}}</span>

</h2>
<mat-dialog-content [formGroup]="form">


  <mat-tab-group (selectedTabChange)="onSelectedTabChanged($event)">
    <mat-tab class="modal-tab" label="{{'ARTICLE.TAB.0' | translate}}"></mat-tab>
    <mat-tab class="modal-tab" label="{{'ARTICLE.TAB.2' | translate}}"></mat-tab>
  </mat-tab-group>

  <form [formGroup]="form">
    <div class="tab-content-container">

      <div [hidden]="activeTabIndex !== 1" class="uploader-container">
        <img *ngIf="selectedHomeCarouselItem && selectedHomeCarouselItem.imageUrl"
             [src]="selectedHomeCarouselItem.imageUrl">
        <mat-icon class="dark" *ngIf="selectedHomeCarouselItem && selectedHomeCarouselItem.imageUrl"
                  (click)="deleteCoverImage()">delete
        </mat-icon>
        <app-custom-drop-zone
          *ngIf="!selectedHomeCarouselItem || !selectedHomeCarouselItem.imageUrl"
          (uploadFinished)="onUploadFinished($event)"
          [uploadPath]="'homeCarousel'"
          [height]="'250px'">
        </app-custom-drop-zone>
      </div>


      <div [hidden]="activeTabIndex !== 0">
        <div class="row">
          <div class="col-12">

            <mat-form-field>

              <input matInput
                     type="text"
                     placeholder="{{'HOME_CAROUSEL.TITLE' | translate}}"
                     formControlName="title">

            </mat-form-field>

          </div>

          <div class="col-12">
            <app-building-side-selector [parentForm]="form" [buildingSide]="selectedHomeCarouselItem.side"></app-building-side-selector>
          </div>

          <div class="col-12">
            <mat-form-field>
              <mat-label>{{'HOME_CAROUSEL.SUMMARY' | translate}}</mat-label>
              <textarea matInput formControlName="summary" matTextareaAutosize matAutosizeMinRows=2
                        matAutosizeMaxRows=5></textarea>
            </mat-form-field>
          </div>

        </div>
      </div>

    </div>
  </form>

</mat-dialog-content>

<app-modal-footer [disabled]="!form.valid" (submit)="save()" (close)="close()"></app-modal-footer>
